import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { ProfileContext } from 'context';
import { IntlHelmet, LanguageProvider, LanguageSelector, OfflineOverlay } from 'modules/App';
import ClinicManagement from 'modules/ClinicManagement';
import Hcp from 'modules/Hcp';
import Visit from 'modules/Visit';
import messages from '../../messages';
import styles from './PreviewResultsLayout.pcss';
const profileContext = {
    selectors: {
        activePatient: Hcp.selectors.activePatient,
        phiSet: Hcp.selectors.phiSet,
        phiSetDocumentId: Hcp.selectors.phiSetDocumentId,
        readings: Hcp.selectors.readings,
        cgmReadings: Hcp.selectors.cgmReadings,
        highlightedReadings: Hcp.selectors.highlightedReadings,
        measurements: Hcp.selectors.measurements,
        measurementsBatchesIndex: Hcp.selectors.measurementsBatchesIndex,
        notes: Hcp.selectors.notes,
        relatedData: Hcp.selectors.relatedData,
        timeSeriesResources: Hcp.selectors.timeSeriesResources,
        clinicSettings: ClinicManagement.selectors.clinicSettings,
        activeVisit: Visit.selectors.activeVisit
    },
    actions: {
        setReadings: Hcp.actions.setReadings,
        storeReadingsSuccess: Hcp.actions.setImportedReadings
    }
};
const PreviewResultsLayout = ({ metaTitleMessage, metaDescriptionMessage, children })=>{
    useStyles(styles);
    const titleMessage = metaTitleMessage || messages.meta.title;
    const descriptionMessage = metaDescriptionMessage || messages.meta.description;
    return /*#__PURE__*/ _jsx(LanguageProvider, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.root),
            children: [
                /*#__PURE__*/ _jsx(IntlHelmet, {
                    titleMessage: titleMessage,
                    descriptionMessage: descriptionMessage
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.container, styles.layoutContainer),
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.layout,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: cn(styles.sidebarHolder),
                                children: /*#__PURE__*/ _jsx(LanguageSelector, {
                                    hideLabel: true,
                                    className: "sidebar__languageSelector",
                                    withTooltip: true
                                })
                            }),
                            /*#__PURE__*/ _jsx(ProfileContext.Provider, {
                                value: profileContext,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "content",
                                    children: children
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(OfflineOverlay, {})
            ]
        })
    });
};
export default PreviewResultsLayout;
